// App.jsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Map } from './pages/map/Map';
import AdminDashboard from './pages/admin/AdminDashboard';
import './styles/main.scss';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="pages">
          <Routes>
            <Route path="/" element={<Map />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
